// extracted by css-extract-rspack-plugin
export default {"block":"block-Ek5KBS"};